import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AUDITS_LIST_KEY } from 'modules/audit/management/constants';
import { AuditService } from 'modules/audit/management/services';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteAudit = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('audit');
  return useMutation(() => AuditService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries([AUDITS_LIST_KEY]);
      queryClient.invalidateQueries([id]);
    },
  });
};
